import * as types from './types';

export const fetchDataAction = () => ({ type: types.AUTH_DATA_FETCH });
export const fetchSuccess = payload => ({ type: types.AUTH_DATA_SUCCESS, payload });
export const fetchFailure = () => ({ type: types.AUTH_DATA_FAILURE });

export const fetchData = () => (
  (dispatch, getState, api) => {
    dispatch(fetchDataAction());

    return api.getAccount()
      .then(response => {
        dispatch(fetchSuccess(response.data));
      })
      .catch(error => {
        dispatch(fetchFailure(error));
      });
  }
);



// WEBPACK FOOTER //
// ./src/redux/auth/actions.js